<h3>Cadastro de Contraparte</h3>

<form #thisForm="ngForm">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Gerenciar Contraparte</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="form-group col-md-12">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            name="name"
            data-cy="name"
            [(ngModel)]="model.name"
            placeholder="Nome"
            maxlength="70"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="form-group col-md-12"
          [class.has-error]="hasError('document')"
        >
          <label>Documento</label>
          <input
            type="text"
            class="form-control"
            name="document"
            data-cy="document"
            [(ngModel)]="model.document"
            placeholder="Documento"
            mask="000.000.000-00||00.000.000/0000-00"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="form-group col-md-12"
          [class.has-error]="hasError('selicAccount')"
        >
          <label>Conta Selic</label>
          <input
            type="text"
            class="form-control"
            name="selicAccount"
            data-cy="selicAccount"
            [(ngModel)]="model.selicAccount"
            placeholder="Conta Selic"
            maxlength="10"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="form-group col-md-12"
          [class.has-error]="hasError('cetipAccount')"
        >
          <label>Conta Cetip</label>
          <input
            type="text"
            class="form-control"
            name="cetipAccount"
            data-cy="cetipAccount"
            [(ngModel)]="model.cetipAccount"
            placeholder="Conta Cetip"
            maxlength="10"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="form-group col-md-12"
          [class.has-error]="hasError('brokerAccount')"
        >
          <label>Conta de Corretagem</label>
          <input
            type="text"
            class="form-control"
            name="brokerAccount"
            data-cy="brokerAccount"
            [(ngModel)]="model.brokerAccount"
            placeholder="Conta de Corretagem"
            maxlength="10"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="form-group col-md-12"
          [class.has-error]="hasError('b3Account')"
        >
          <label>Conta B3</label>
          <input
            type="text"
            class="form-control"
            name="b3Account"
            data-cy="b3Account"
            [(ngModel)]="model.b3Account"
            placeholder="Conta B3"
            maxlength="10"
          />
        </div>
      </div>
      <div class="row mb-2" *ngFor="let account of accounts; let i = index">
        <div
          class="form-group col-4"
          [class.has-error]="hasError('bank', true, i)"
        >
          <label>Banco</label>
          <app-select-bank
            #bankComponent
            name="bank-{{ i }}"
            data-cy="bank-{{ i }}"
            [banks]="banksList"
            [(selectedBankId)]="accounts[i].bank"
          ></app-select-bank>
        </div>
        <div
          class="form-group col-4"
          [class.has-error]="hasError('branch', true, i)"
        >
          <label>Agencia</label>
          <input
            type="text"
            class="form-control"
            name="branch-{{ i }}"
            data-cy="branch-{{ i }}"
            [(ngModel)]="accounts[i].branch"
            placeholder="Agencia"
            required
          />
        </div>

        <div
          class="form-group col-4"
          [class.has-error]="hasError('account', true, i)"
        >
          <label>Conta</label>
          <input
            type="text"
            class="form-control"
            name="account-{{ i }}"
            data-cy="account-{{ i }}"
            [(ngModel)]="accounts[i].account"
            placeholder="Conta"
            required
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="form-group actions">
      <input
        type="button"
        value="Adicionar novo banco"
        data-cy="submit"
        class="btn btn-primary"
        (click)="addBank()"
      />
      <input
        type="button"
        value="Salvar"
        data-cy="submit"
        class="btn btn-primary"
        appDebounceClick
        (debounceClick)="submit()"
        [debounceTime]="200"
      />
    </div>
  </div>
</form>
